import { axiosConfig } from './axios-config.js'

export const report = {
  // 取得門市
  create: (data, token) => axiosConfig.post('/api/console/report', data, token),

  // 創建門市
  get: (key, token) => axiosConfig.get(`/api/console/report/${key}`, token)
}
